<div class="container dialog-container">

  <h2 *ngIf="data.edit" class="display-6">Edit Vessel</h2>
  <h2 *ngIf="!data.edit" class="display-6">Add Vessel</h2>


  <form [formGroup]="form">
    <div class="row">

      <mat-form-field appearance="fill">
        <mat-label>Vessel Name</mat-label>
        <input matInput formControlName="vesselName" required>
        <mat-error *ngIf="form.get('vesselName')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="form.get('vesselName')?.errors?.pattern">Invalid character</mat-error>
      </mat-form-field>

    </div>

    <div *ngIf="!data.mothership" class="row" style="padding-bottom: 15px;">

      <mat-form-field appearance="fill">
        <mat-label>Vessel Coast Guard Number</mat-label>
        <input matInput formControlName="vesselNumber" (keyup.enter)="addVessel()" required>
        <mat-error *ngIf="form.invalid">Invalid - 6 digit numeric or 7-8 digit alphanumeric required</mat-error>
      </mat-form-field>

    </div>
  </form>

  <!-- Delete or add new vessel -->
  <div class="row buttons">

    <button *ngIf="!data.edit"
            mat-fab
            class="text-blue-button"
            type="button"
            aria-label="Add Vessel"
            (click)="cancelVessel()">
      Cancel
    </button>

    <button *ngIf="data.edit"
            mat-fab
            class="text-blue-button"
            type="button"
            aria-label="Add Vessel"
            (click)="deleteVessel()">
      Delete
    </button>

    <button mat-fab
            class="text-button"
            type="button"
            aria-label="Add Vessel"
            (click)="addVessel()">
      OK
    </button>

  </div>

</div>
